import { css, type Theme } from "@emotion/react";
import { typography } from "aviary-tokens";

import { layers } from "@styles";

export const dropdownHeader = (theme: Theme) => css`
  position: sticky;
  top: 0;
  margin-left: -0.5rem;
  margin-right: -0.5rem;
  z-index: ${layers.indexDropdownMax};

  &:after {
    content: "";
    width: 100%;
    height: 0.5rem;
    position: absolute;
    top: -0.5rem;
    left: 0;
    background-color: ${theme.surface.interactiveBackground};
  }
`;

export const headerContent = (theme: Theme) => css`
  background-color: ${theme.surface.interactiveBackground};
  padding: 0rem 3rem 0.5rem 1rem;
  font-weight: ${typography.weightSemiBold};
  font-size: 1rem;
  text-align: left;
  color: ${theme.text.emphasis};
  white-space: nowrap;
`;

export const largePadding = css`
  padding: 0.5rem 3rem 1rem 1.5rem;
`;

export const dividerShims = css`
  h1,
  h2,
  h3,
  h4,
  p:not(:last-child) {
    margin-bottom: 0 !important;
  }
`;
